// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { NormalStatus, NormalStatusT } from "./normal-status";
import { ValuedStatus, ValuedStatusT } from "./valued-status";

export enum StatusVariant {
  NONE = 0,
  NormalStatus = 1,
  ValuedStatus = 2,
}

export function unionToStatusVariant(
  type: StatusVariant,
  accessor: (obj: NormalStatus | ValuedStatus) => NormalStatus | ValuedStatus | null,
): NormalStatus | ValuedStatus | null {
  switch (StatusVariant[type]) {
    case "NONE":
      return null;
    case "NormalStatus":
      return accessor(new NormalStatus())! as NormalStatus;
    case "ValuedStatus":
      return accessor(new ValuedStatus())! as ValuedStatus;
    default:
      return null;
  }
}

export function unionListToStatusVariant(
  type: StatusVariant,
  accessor: (index: number, obj: NormalStatus | ValuedStatus) => NormalStatus | ValuedStatus | null,
  index: number,
): NormalStatus | ValuedStatus | null {
  switch (StatusVariant[type]) {
    case "NONE":
      return null;
    case "NormalStatus":
      return accessor(index, new NormalStatus())! as NormalStatus;
    case "ValuedStatus":
      return accessor(index, new ValuedStatus())! as ValuedStatus;
    default:
      return null;
  }
}

export type StatusVariantT =
  | { type: "NONE"; value: null }
  | { type: "NormalStatus"; value: NormalStatusT }
  | { type: "ValuedStatus"; value: ValuedStatusT };
